import React from 'react'
import shadows from './shadows'
import typography from './typography'
import IRANSansWoff2 from '../assets/fonts/iransans/woff2/IRANSansWeb.woff2'

const IRANSans = {
  fontFamily: 'IRANSans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  src: `
  local('IRANSans'),
  local('IRANSans-Regular'),
  url(${IRANSansWoff2}) format('woff2')
`,
}

const themeObject = {
  direction: 'rtl',
  overrides: {
    MuiIconButton: {
      root: {
        padding: 8,
      },
    },
    MuiToolbar: {
      root: {
        minHeight: '54px !important',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '@font-face': [IRANSans],
      },
    },
    MUIDataTableFilter: {
      root: {
        minWidth: '90vw',
        '@media (min-width: 0px)': {
          minWidth: '90vw',
        },
        '@media (min-width: 800px)': {
          minWidth: '40vw',
        },
      },
      header: {
        direction: 'rtl',
      },
    },
  },
  typography: {
    ...typography,
    fontFamily: ['IRANSans', 'sans-serif'].join(','),
  },
  palette: {
    type: 'light',
  },
  shadows,
}

export const useDarkMode = () => {
  const [theme, setTheme] = React.useState(themeObject)
  const { palette: { type } } = theme
  const toggleDarkMode = () => {
    const updatedTheme = {
      ...theme,
      palette: {
        ...theme.palette,
        type: type === 'light' ? 'dark' : 'light',
      },
    }
    setTheme(updatedTheme)
  }
  return [theme, toggleDarkMode]
}

export default themeObject
